import { Input, Button, Switch, Form, Upload, Select } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { addCategogy, modifyCategory } from './categorySlice';
import type { UploadProps } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';

export default function AddCategory(): JSX.Element {

    const dispatch = useDispatch();
    const { setModelChange, messageApi, editCategory, setEditCategory } = React.useContext(CommonContext) as CommonContextType;
    const [form] = Form.useForm();
    const [file, setFile] = useState<any>()
    const [isDisabled, setIsDisabled] = useState(false);
    const [fileList, setFileList] = useState<any>();
    // const ProductTypesData = useSelector((state: AppState) => state.ProductTypes.ProductType);
    // const [type_array, setTypeArray] = useState([{}]);
    // const [type_nm_val, setTypeNmVal] = useState(null);
    // const [body_size_array, setBodySizeArray] = useState([{}]);
    const BodySizes = useSelector((state: AppState) => state.BodySizes);
    /* 
        useEffect(() => {
            if (BodySizes.BodySize.length > 0) {
                const arr = BodySizes.BodySize.map((el: any) => ({ value: el.id, label: el.bodysize_value }))
                setBodySizeArray(arr)
            }
    
        }, [BodySizes]);
     */
    React.useEffect(() => {
        /*  if (ProductTypesData.length > 0) {
 
             const a = [{ value: '', label: '' }];
             const arr = ProductTypesData.map((el: any) => ({ value: el.id, label: el.type_name }))
             setTypeArray([...a, ...arr]);
 
         } */


        if (editCategory?.id) {
            setIsDisabled(editCategory.disabled)
            setFileList([
                {
                    name: editCategory.category_img_url.split('/').pop(),
                    url: process.env.REACT_APP_AZURE_BLOB_STORAGE_API + editCategory.category_img_url,
                }
            ])
            setFile(null)
            form.setFieldsValue(editCategory)
            // setTypeNmVal(editCategory?.product_type?.id) //, { body_sizes: editCategory?.body_size?.id }
            // form.setFieldsValue(Object.assign({ type_nm: editCategory?.product_type?.id }, editCategory))
        } else {
            form.resetFields();
            setIsDisabled(false);
            setFileList(null);
            setFile(null);
        }
    }, [editCategory, form]);

    const onFinish = (values: any) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('category_name', values.category_name)
        formData.append('category_code', values.category_code.toUpperCase())
        formData.append('disabled', JSON.stringify(isDisabled))
        formData.append('order', values.order)

        // formData.append('product_type', (values?.type_nm) ? values.type_nm : "")
        // formData.append('body_size', (values?.body_sizes) ? values.body_sizes : "")

        if (editCategory?.id) {
            formData.append('category_img_url', values.category_img_url)
            formData.append('updated_datetime', new Date().toLocaleString() + "");
            dispatch(modifyCategory(formData, editCategory?.id))
            /* messageApi.open({
                type: 'success',
                content: 'Category updated successfully',
            }); */
        } else {
            formData.append('created_datetime', new Date().toLocaleString() + "");
            dispatch(addCategogy(formData))
        }

        setModelChange(false)
        setEditCategory(null)
        form.resetFields();

        setIsDisabled(false);
        setFileList(null);
        setFile(null);
    };
    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };
    const onChangeFile = (e: any) => {
        setFile(e.file.originFileObj)
    }
    const onToggleChange = (checked: boolean) => {
        setIsDisabled(checked)
    };

    const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
        newFileList[0].status = 'done'
        setFile(newFileList[0].originFileObj)
        setFileList(newFileList);
    }

    const props = {
        showUploadList: {
            showRemoveIcon: false,
            showPreviewIcon: false,
        },
    }
    return (
        <Form
            form={form}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item name='key'>
                <Input type='hidden' />
            </Form.Item>

            <Form.Item>
                <Upload.Dragger
                    {...props}
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleChange}
                    maxCount={1}
                    accept="image/*"
                >
                    <div>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Drag file to upload</p> Or Select file from your PC
                    </div>
                </Upload.Dragger>
            </Form.Item>


            <Form.Item label="Order"
                name='order'
                rules={[
                    {
                        required: true,
                        message: 'Please enter Order',
                    },
                    {
                        pattern: /^[0-9]+$/,
                        message: 'Please enter numbers only',
                    },
                ]}>
                <Input />
            </Form.Item>

            <Form.Item label="Category Code"
                name='category_code'
                rules={[
                    {
                        required: true,
                        message: 'Please enter Category code',
                    },
                ]}>
                <Input onInput={e => (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toUpperCase()} />
            </Form.Item>

            <Form.Item label="Category Name"
                name='category_name'
                rules={[
                    {
                        required: true,
                        message: 'Please enter Category name',
                    },
                ]}>
                <Input />
            </Form.Item>

            {/*  <Form.Item label="Product Type"
                name='type_nm'
                rules={[
                    {
                        required: false
                    },
                ]}>
                <Select onChange={setTypeNmVal}
                    // style={{ width: 120 }}
                    options={type_array}
                />
            </Form.Item> */}

            {/*  {type_nm_val == 2 ?
                <Form.Item label="Body Size"
                    name='body_sizes'
                    rules={[
                        {
                            required: true,
                            message: 'Please select body size',
                        },
                    ]}>
                    <Select //value={body_size}
                        options={body_size_array}>
                    </Select>
                </Form.Item>
                : null} */}

            <Form.Item >
                <Switch style={{ backgroundColor: isDisabled ? '#bfbfbf' : '#1577ff' }} checked={isDisabled} onChange={onToggleChange} checkedChildren="Disabled" unCheckedChildren="Enabled" />
            </Form.Item>
            <Form.Item>
                <Button style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} type="primary" htmlType="submit" >{editCategory?.id ? 'Update' : 'Create'}</Button>
            </Form.Item>
        </Form>
    )
}
